import efocats_validate_core from './efocats_validate_core.js';
import EFOcats_error_info from '../efocats_error_info.js';
/**
 * URLチェッククラス
 */
export default class EFOcats_validate_colorme_url extends efocats_validate_core {
  /**
   * エラーチェック
   */
  validate(checkData) {
    if (checkData.attr('type') !== 'url') {
      return new EFOcats_error_info('success', '', '', '');
    }

    let result = new EFOcats_error_info('success', '', '', '');
    const material_val = checkData.val();

    if (material_val.match(/https?:\/\/[-_.!~*'()a-zA-Z0-9;/?:@&=+$,%#\u3000-\u30FE\u4E00-\u9FA0\uFF01-\uFFE3]+/)) {
      result = new EFOcats_error_info('success', '', '', '');
    } else {
      result = new EFOcats_error_info('error', this.langagerList('urlエラー'), '', 'urlエラー');
    }

    return result;
  }
}
